<template>
    <div class="flex items-center justify-center md:justify-end" :class="[padding > 0 ?  ('p-' + padding) : '']">
        <!-- Pager navigation -->
        <div class="flex items-center text-gray-400" :class=" disabled ? disabledCursor: ''">
            <!-- Previous arrow button -->
            <button @click="goToPage(meta.prev_page_url)"
                    :disabled="meta.prev_page_url == null || disabled"
                    class="text-center outline-none px-1"
                    :class="[meta.prev_page_url == null || disabled? 'text-gray-300 cursor-default' : 'hover:text-gray-600' , disabled ? disabledCursor: '']"
                    :title="previousPageToolTip">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
                </svg>
            </button>

            <!--Home/First Page-->
            <button @click="goToPage(meta.first_page_url)"
                    :title="homePageToolTip"
                    :disabled="meta.first_page_url == null || meta.current_page === 1 || disabled"
                    class="text-center outline-none"
                    :class="[meta.first_page_url == null || meta.current_page === 1 || disabled? '' : 'hover:text-gray-600', disabled ? disabledCursor: '']">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
                </svg>
            </button>

            <!-- Next arrow button -->
            <button @click="goToPage(meta.next_page_url)"
                    :disabled="meta.next_page_url == null || disabled"
                    class="text-center outline-none px-1"
                    :class="[meta.next_page_url == null || disabled ? 'text-gray-300 cursor-default' : 'hover:text-gray-600', disabled ? disabledCursor: '']"
                    :title="nextPageToolTip">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "PlainPagination",

    props: {
        meta: {
            required: true,
            description: "The meta data of the pagination result",
        },
        padding: {
            required: false,
            default: 0,
            description: "Padding for the component"
        },
        disabled: {
            required: false,
            type: Boolean,
            default: false
        },
        disabledMessage: {
            required: false,
            type: String,
            default: ""
        },
        disabledCursor: {
            required: false,
            type: String,
            default: "cursor-not-allowed cursor-default",
            description: "The cursor to use when the component is disabled"
        },
    },

    computed: {
        previousPageToolTip () {
            if (this.disabled) {
                return this.disabledMessage;
            }

            return this.meta.prev_page_url ? "Previous page" : "No more pages that way";
        },

        homePageToolTip () {
            if (this.disabled) {
                return this.disabledMessage;
            }

            return this.meta.current_page === 1 ? "You are already on the first page" : "Go to first page";
        },

        nextPageToolTip () {
            if (this.disabled) {
                return this.disabledMessage;
            }

            return this.meta.next_page_url ? "Next page" : "No more pages that way";
        },

    },

    methods: {
        goToPage (pageUrl) {
            this.$emit("page-changed", pageUrl);
        },
    },
};
</script>
